import React from "react";
import { Button } from "../Button/Button";
import styles from "./Pagination.module.scss";
import clsx from "clsx";
import { PaginationButton } from "../PaginationButton/PaginationButton";
import { getPaginationItems, SEPARATOR1, SEPARATOR2 } from "./utils";

type PaginationProps = {
  totalPages: number;
  currentPage: number;
  length: number;
};
type ButtonPaginationProps = PaginationProps & {
  onClick: (page: number) => void;
};

export const Pagination: React.FC<
  React.PropsWithChildren<ButtonPaginationProps>
> = ({ currentPage, totalPages, length, ...otherProps }) => {
  const pageNumbersToLink = getPaginationItems(currentPage, totalPages, length);

  return (
    <div className={styles.container} data-content-name="pagination">
      <div key="prev">
        <PaginationButton
          disabled={currentPage == 1}
          onClick={() => otherProps.onClick(currentPage - 1)}
          arrow="left"
          dataContentPiece="prev"
        ></PaginationButton>
      </div>
      <ul className={styles.list}>
        {pageNumbersToLink.map((page) => {
          if (page == SEPARATOR1 || page == SEPARATOR2) {
            return (
              <li key={page} className={clsx(styles.item)}>
                &hellip;
              </li>
            );
          }
          return (
            <li
              key={page}
              className={clsx(styles.item, {
                [styles.active]: currentPage == page,
                [styles.activeSibling]: page == currentPage - 1
              })}
            >
              <button
                className={styles.pageButton}
                onClick={() => otherProps.onClick(page)}
                data-content-piece={`page__${page}`}
              >
                {page}
              </button>
            </li>
          );
        })}
      </ul>
      <div key="next">
        <PaginationButton
          disabled={currentPage == totalPages}
          onClick={() => otherProps.onClick(currentPage + 1)}
          arrow="right"
          dataContentPiece="next"
        ></PaginationButton>
      </div>
    </div>
  );
};
